<template>
  <div class="animated fadeIn">
    <b-card no-body class="p-4 mb-2">
      <h3>Välkommen till Preservetime 1.0.5</h3>

      <span v-if="loginState.user && loginState.user.isEmployee && salarySpecification">Din senaste lönespecifikation finns att hämta <router-link class="alert-link" :to="`/salaryspecifications/${salarySpecification[0].id}`">här</router-link>. 
      Du kommer få <b>{{formatPrice(salarySpecification[0].netSalary)}}</b> kronor utbetalad <b>{{salarySpecification[0].paymentDate | moment("YYYY-MM-DD") }}</b>.</span>
    </b-card>
    
    <RevenueChartCard v-if="loginState.user && loginState.user.isEmployee && loginState.isAdministrator"/>
    <OccupancyChartCard v-if="loginState.user && loginState.user.isEmployee"/>
  </div>
</template>

<script>

import { Callout } from '@coreui/vue'
import { salarySpecificationService } from "../shared/services";
import RevenueChartCard from './dashboard/RevenueChartCard'
import OccupancyChartCard from './dashboard/OccupancyChartCard'

export default {
  name: '',
  components: {
    RevenueChartCard,
    OccupancyChartCard
  },
  computed: {
      dateLabel() {
        if(this.yearButtonEnabled) return this.$moment().year();
        return `${this.monthNames[this.$moment().month()]} ${this.$moment().year()}`

      },
  },
  data: function () {
    return {
      salarySpecification : null,
    }
  },
  methods: {
    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
  },

  async mounted() {

    try {
      var year = this.$moment.year;
      var month = this.$moment.month;
      this.salarySpecification = await salarySpecificationService.getByUser(this.loginState.user.id, year, month);
    }
    catch{

    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
